export const toFixed = (number, decimalNumber = 0) => {
  return (
    Math.round(number * Math.pow(10, decimalNumber)) /
    Math.pow(10, decimalNumber)
  );
};
